module.exports = __webpack_public_path__ + "img/logo_RivalSurvey.a6bba447.jpg";